import script from "./OffersActions.vue?vue&type=script&setup=true&lang=js"
export * from "./OffersActions.vue?vue&type=script&setup=true&lang=js"

import "./OffersActions.vue?vue&type=style&index=0&id=b63e0b9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b63e0b9a"]])

export default __exports__